import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { useMemo } from 'react';
import { useEuiTheme } from '../theme/hooks';
import { euiPaletteColorBlind, euiPaletteColorBlindBehindText, euiPaletteComplementary, euiPaletteCool, euiPaletteForStatus, euiPaletteForTemperature, euiPaletteGray, euiPaletteGreen, euiPaletteRed, euiPaletteWarm } from './eui_palettes';
export var useEuiPaletteColorBlind = function useEuiPaletteColorBlind(args) {
  return _useEuiPaletteFn(euiPaletteColorBlind, args);
};
export var useEuiPaletteColorBlindBehindText = function useEuiPaletteColorBlindBehindText(args) {
  return _useEuiPaletteFn(euiPaletteColorBlindBehindText, args);
};
export var useEuiPaletteForStatus = function useEuiPaletteForStatus(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteForStatus, steps);
};
export var useEuiPaletteForTemperature = function useEuiPaletteForTemperature(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteForTemperature, steps);
};
export var useEuiPaletteComplementary = function useEuiPaletteComplementary(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteComplementary, steps);
};
export var useEuiPaletteRed = function useEuiPaletteRed(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteRed, steps);
};
export var useEuiPaletteGreen = function useEuiPaletteGreen(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteGreen, steps);
};
export var useEuiPaletteCool = function useEuiPaletteCool(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteCool, steps);
};
export var useEuiPaletteWarm = function useEuiPaletteWarm(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteWarm, steps);
};
export var useEuiPaletteGray = function useEuiPaletteGray(steps) {
  return _useEuiPaletteWithStepsFn(euiPaletteGray, steps);
};

/* Internal helper utils */

var _useEuiPaletteFn = function _useEuiPaletteFn(palleteFn, args) {
  var _useEuiTheme = useEuiTheme(),
    euiTheme = _useEuiTheme.euiTheme;
  var colors = euiTheme.colors,
    flags = euiTheme.flags;
  return useMemo(function () {
    return palleteFn(_objectSpread(_objectSpread({}, args), {}, {
      colors: colors.vis,
      hasVisColorAdjustment: flags.hasVisColorAdjustment
    }));
  }, [colors, flags, args, palleteFn]);
};
var _useEuiPaletteWithStepsFn = function _useEuiPaletteWithStepsFn(palleteFn, steps) {
  var _useEuiTheme2 = useEuiTheme(),
    euiTheme = _useEuiTheme2.euiTheme;
  var colors = euiTheme.colors,
    flags = euiTheme.flags;
  return useMemo(function () {
    return palleteFn(steps, {
      colors: colors.vis,
      hasVisColorAdjustment: flags.hasVisColorAdjustment
    });
  }, [colors, flags, steps, palleteFn]);
};